export const onlyNumbers = (str: string): string =>
  str?.replace(/\D/g, "") ?? "";
